import {
    FETCH_LANGUAGES,
    FETCH_LANGUAGES_SUCCESS,
} from 'constants/ActionTypes';

export const fetchLanguages = () => {
    return {
        type: FETCH_LANGUAGES,
    };
};

export const fetchLanguagesSuccess = (languagesList) => {
    return {
        type: FETCH_LANGUAGES_SUCCESS,
        payload: { languagesList }
    };
};
